import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateProjectTaskPopupComponent } from './template-project-task-popup.component';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxDateBoxModule, DxPopupModule, DxSliderModule, DxTextAreaModule, DxValidationSummaryModule, DxValidatorModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [TemplateProjectTaskPopupComponent],
	exports: [TemplateProjectTaskPopupComponent],
  imports: [
    CommonModule,
		DevEpressCommonModule,
    DxPopupModule,
    DxTextAreaModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxDateBoxModule,
		DxSliderModule,
		FormsModule,
		ReactiveFormsModule
  ]
})
export class TemplateProjectTaskPopupModule { }
